import dayjs from 'dayjs'

export default function defineDate (now, params, beginDate) {
  if (!now && !params.get('date') && !beginDate) {
    return null
  } else {
    if (now) return dayjs().toDate()
    else {
      const date = params.get('date') || beginDate
      return new Date(dayjs(date).toDate())
    }
  }
}
